/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomInput } from 'reactstrap';
import { CorporateClub } from '../../../contexts/types/corpclub-type';
import { SyntheticEvent } from '../../../types/event.type';
import { capitalize } from '../../../utils/capitalize';
import { formatCPF } from '../../../utils/formatCPF';
import { useSelectedMembers } from '../../../contexts/SelectedMembers';
import { useExtract } from '../../../contexts/ExtractContext';

interface TableRowProps {
  memberFiltered: CorporateClub[];
  allSelected: boolean;
}

interface PlanList {
  id: string;
  desc: string;
  active: string;
  miles: string;
}

export const TableRow = ({ memberFiltered, allSelected }: TableRowProps) => {
  const navigate = useNavigate();
  const { addMember, removeMember, containsMember } = useSelectedMembers();
  const { setCpf } = useExtract();

  let keyCount = 0;

  const handleProfile = (member: CorporateClub, event: SyntheticEvent) => {
    if (member.cpf === event.target.id && event.target.checked === true) {
      addMember(member as any);
    }

    if (event.target.checked === false) {
      removeMember(member as any);
    }
  };

  const filterMemberFiltered = useMemo(
    () =>
      memberFiltered
        .filter((member) => member.status.toUpperCase() === 'ACTIVE')
        .map((member) => {
          const newPlanList = Object.assign(member.planList)
            .sort((a: PlanList, b: PlanList) => {
              if (+a.miles < +b.miles) {
                return -1;
              }

              if (+a.miles > +b.miles) {
                return 1;
              }

              return 0;
            })
            .filter((item: PlanList) => {
              return item.active === 'true' || item.active;
            });
          return { ...member, planList: newPlanList };
        }),
    [memberFiltered],
  ) as CorporateClub[];

  const getCurrentPlanMiles = (member: CorporateClub) => {
    return new Intl.NumberFormat().format(Number(member.currentPlan.miles));
  };

  return (
    <>
      {filterMemberFiltered?.map((member: CorporateClub) => {
        return (
          <tr className="beneficiaries-table-rows" key={member.cpf}>
            <td>
              <CustomInput
                id={member.cpf}
                type="checkbox"
                onChange={(event) => handleProfile(member, event)}
                checked={containsMember(member as any)}
                disabled={allSelected}
              />
            </td>
            <td>{member.created}</td>
            <td>{capitalize(member.name)}</td>
            <td>{formatCPF(member.cpf)}</td>
            <td>{member.email}</td>
            {member.planList.length ? (
              <td key={member.cpf}>
                {member.planList.map((item: PlanList, index) => {
                  const totalPlans = member.planList.length;
                  const formattedContent = new Intl.NumberFormat().format(Number(item.miles));
                  keyCount += 1;
                  return totalPlans === 1 ? (
                    <span key={keyCount}>{formattedContent}</span>
                  ) : totalPlans === 2 ? (
                    <span key={keyCount}>{index === 0 ? `${formattedContent} e ` : formattedContent}</span>
                  ) : index === 0 ? (
                    <span key={keyCount}>{formattedContent}, </span>
                  ) : index === totalPlans - 2 ? (
                    <span key={keyCount}>{formattedContent} e </span>
                  ) : index === totalPlans - 1 ? (
                    <span key={keyCount}>{formattedContent}</span>
                  ) : (
                    <span key={keyCount}>{formattedContent}, </span>
                  );
                })}
              </td>
            ) : (
              <td>Nenhum</td>
            )}
            <td>{member.currentPlan?.miles ? `Plano ${getCurrentPlanMiles(member)}` : 'Nenhum'}</td>
            <td
              className="vbz-icon-corporates-club-arrow"
              onClick={() => {
                setCpf(member.cpf);
                navigate(`/clube-corporativo/?p=perfil-colaborador&cpf=${member.cpf}`, { state: member });
              }}
              data-testid="chevron-click-test"
            />
          </tr>
        );
      })}
    </>
  );
};
